import React from "react";
import ReactModal from "react-modal";
import { Draggable} from "@components";
import { useQuery } from "@tanstack/react-query";
import { get } from "@utils/axios_api";
import { AuthHook } from "@hooks";
import { qk } from "@utils/queryKey";

const ApplyCompleteModal = ({ isOpen, onClose, lecture, }) => {
    const { auth } = AuthHook();
    const position = Draggable({ isOpen, dragHandle: ".modal-header" });

    const containerStyle = {
        maxWidth: "1100px",
        minWidth: "1100px",
        maxHeight: "750px",
        minHeight: "750px",
        transform: `translate(0%, 0%) translate(${position.x}px, ${position.y}px)`
      };

    //   queryKey: ['lectureDetail', lectureId],
    //   queryFn: () => get('/lecture/detail', { params: { lectureId } }),
    //   enabled: !!lectureId,   
    const shouldFetch = !!lecture?.lectureId && isOpen && auth.isAuthenticated;
    
    const { data: applyMember } = useQuery({
        queryKey: qk.applyModal(lecture?.lectureId),
        queryFn: () => get("/lecture/applyMember", { params: { lectureId: lecture?.lectureId } }),
        enabled : shouldFetch,
    });

    const applyMem = applyMember?.result ?? {};

    const statusText = {
        A: "교육신청이 접수되었습니다.",
        B: "교육 신청이 완료되었습니다.",
        C: "교육 신청이 취소되었습니다.",
        N: "교육 신청을 취소하였습니다.",
        R: "교육 신청이 반려되었습니다."
    }[applyMem.applyStatus] || "";

    const showWaitNo = !!applyMem.applyNo && applyMem.applyNo > 0;
    // const showReceiptBtn = applyMem.applyStatus === 'B';

    return (
    <ReactModal
        isOpen={isOpen}
        onRequestClose={onClose}
        overlayClassName="modal-overlay"
        className="modal-wrap"
    >
        <div id="modal-container"  style={containerStyle}>
            <div className="modal-header"  style={{ cursor: "move" }}>
                <h3>교육신청 정보확인</h3>
                <button type="button" className="modal-btn-close" onClick={onClose}>
                    <span className="modal-btn-span">X</span>
                </button>
            </div>
            <div className="modal-content">
                <div className="" style={{margin:'20px', fontSize:"1.5rem", fontWeight:"bold"}}>
                    {statusText}
                    {showWaitNo && (
                        <span style={{ color: "red", marginLeft: "10px" }}>
                            신청 대기 번호 : {applyMem.applyNo}
                        </span>
                    )}
                </div>
                <span className="modal_span">교육 정보</span>
                <div className="lineTop_tb01">
                    <table className="lineTop_tb2 table-td-left">
                    <colgroup>
                        <col style={{ width: '150px' }} />
                        <col />
                    </colgroup>
                    <tbody>
                        <tr>
                        <th>교육명</th>
                        <td>{lecture?.lectureNm || ''}</td>
                        </tr>
                        <tr>
                        <th>교육일자</th>
                        <td>{lecture.firstDt && lecture.lastDt ? `${lecture.firstDt} ~ ${lecture.lastDt}` : lecture.firstDt || "-"} ({lecture?.eduHours}시간)</td>
                        </tr>
                        <tr>
                        <th>수강정원</th>
                        <td>{lecture.curStudentCnt}/{lecture.eduStdntLimit}  </td>
                        </tr>
                        <tr>
                        <th>교육비</th>
                        <td >{lecture.eduPee ? `₩ ${lecture.eduPee.toLocaleString()} ` : "-"}</td>
                        </tr>
                        <tr>
                        <th>결제방법</th>
                        <td >{applyMem?.payType === 'A' ? '무통장입금' : applyMem?.payType === 'B' ? '현장결제' : '카드결제'}</td>
                        </tr>
                        {applyMem?.payType === 'A' && (
                            <>
                            <tr>
                                <th>예금주</th>
                                <td>(주식회사) 아토스</td>
                                </tr>
                                <tr>
                                <th>입금계좌</th>
                                <td>(한국산업은행) 022-2600-4645-704</td>
                                </tr>
                                <tr>
                                <th>입금자명</th>
                                <td >{applyMem?.depositName || '-'}</td>
                            </tr>
                            </>
                        )}
                        
                        <tr>
                        <th>입금상태</th>
                        <td >{applyMem?.depositStatus || '-'}</td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                {/* <div style={{marginTop:20, textAlign:"center"}}>
                        {showReceiptBtn && (
                            <button className="btn btn_download"
                                onClick={() => window.open(`/lecture/receipt?lectureId=${lecture?.lectureId}`)}>
                                접수확인증
                            </button>
                        )}
                </div> */}
                <div className="text-cent">
                    <button className="btn btn-blue mt18" onClick={onClose}>닫기</button>
                </div>
            </div>
        </div>
    </ReactModal>
    );
}

export {ApplyCompleteModal}